import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Card, CardBody, CardTitle, Button, Input, Row, Col } from 'reactstrap';

import IntlMessages from '../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../components/DatatablePagination';
import { ExportToCsv } from 'export-to-csv';
import moment from 'moment';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_VisitorsGroupsContact_Stats } from '../../../../../constants/APIs';
import classnames from 'classnames';
const Contact = ({ labels, data, timeZone, propertyId ,height}) => {
  moment.tz.setDefault(timeZone);
  const csvLink = useRef(null);
  const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: false,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
  };

  const csvExporter = new ExportToCsv(options);
  const [downloadInput, setDownloadInput] = useState('0');
  const [ApiState, setApiState] = useState('default');
  const downloadCurrent = () => {
    setApiState('processing');
    if (downloadInput === '0') {
      csvExporter.generateCsv(data);
      setApiState('success');
    } else {
      var startDate = '';
      var endDate = moment(moment().format('YYYY-MM-DD') + ' 23:59:59')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');

      if (downloadInput === '1') {
        startDate = moment(
          moment().subtract(6, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '2') {
        startDate = moment(
          moment().subtract(29, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '3') {
        const today = moment();
        startDate = moment(
          moment(today).isoWeekday(1).format('YYYY-MM-DD') + ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');

        endDate = moment(
          moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '4') {
        startDate = moment(
          moment().startOf('month').format('YYYY-MM-DD') + ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '5') {
        startDate = moment(
          moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
          ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');

        endDate = moment(
          moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
          ' 23:59:59'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '6') {
        startDate = moment(
          new Date().getFullYear() + '-01-01' + ' 00:00:00'
        ).format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '7') {
        startDate = moment(
          new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00'
        ).format('YYYY-MM-DD HH:mm:ss');
        endDate = moment(
          new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00'
        ).format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '8') {
        startDate = '2019-01-01';
      }

      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startDate,
          dateTo: endDate,
          propertyId: propertyId,
        },
      }).then((res) => {
        setApiState('success');
        csvExporter.generateCsv(res.data);
      });
    }
  };
  const handleTextChange = (e) => {
    setDownloadInput(e.target.value);
  };

  return (
    <Card>
      <div style={{ padding: '15px', paddingBottom: '0px' }}>
        <div className="float-left float-none-xs">
          <div className="d-inline-block">
            <h5 className="d-inline">Contacts</h5>
            <span className="text-muted text-small d-block">
              Stored Contacts from Pre Chat Form & Leave Message
            </span>
          </div>
        </div>
     {height === undefined &&   <div className="float-right form-inline text-right">
          <Input
            type="select"
            value={downloadInput}
            name="type"
            onChange={(event) => handleTextChange(event)}
          >
            <option value="0">Current</option>
            <option value="1">Last 7 Days</option>
            <option value="2">Last 30 Days</option>
            <option value="3">This Week</option>
            <option value="4">This Month</option>
            <option value="5">Previous Month</option>
            <option value="6">Year to Date</option>
            <option value="7">Last Year</option>
            <option value="8">All</option>
          </Input>
          {sessionStorage.getItem("lock") === "true" &&
            <Button
              color="primary"
              onClick={downloadCurrent}
              className={`ml-2 default btn-multiple-state ${classnames({
                'show-spinner': ApiState === 'processing',
                'show-success': ApiState === 'success',
                'show-fail': ApiState === 'fail',
              })}`}
            >
              <span className="spinner d-inline-block">
                <span className="bounce1" />
                <span className="bounce2" />
                <span className="bounce3" />
              </span>
              <span className="icon success">
                <i className="simple-icon-check" />
              </span>
              <span className="icon fail">
                <i className="simple-icon-exclamation" />
              </span>
              <span className="label">Download</span>
            </Button>
          }
        </div>}
      </div>        

      <CardBody>
        {height !== undefined? <ReactTable style={{height:'48rem'}}
          data={data}
          columns={labels}
          defaultPageSize={height !== undefined ?15:5}
          filterable={true}
          showPageJump={true}
          PaginationComponent={DataTablePagination}
          showPageSizeOptions={true}
          defaultCanFilter={true}
          defaultSorted={[
            {
              id: 'name',
              desc: false,
            },
          ]}
        /> :
        <ReactTable
          data={data}
          columns={labels}
          defaultPageSize={height !== undefined ?15:5}
          filterable={true}
          showPageJump={true}
          PaginationComponent={DataTablePagination}
          showPageSizeOptions={true}
          defaultCanFilter={true}
          defaultSorted={[
            {
              id: 'name',
              desc: false,
            },
          ]}
        />}
      </CardBody>
    </Card>
  );
};

export default Contact;
